import { Route, RouteConfig } from 'vue-router'

import PageHome from '@/app/views/home/PageHome.vue'
import PageSearch from '@/app/views/PageSearch.vue'

import PagePostsByAuthor from '@/app/views/posts/PagePostsByAuthor.vue'
import PagePostsByDate from '@/app/views/posts/PagePostsByDate.vue'
import PagePostsByTag from '@/app/views/posts/PagePostsByTag.vue'
import PagePostsDates from '@/app/views/posts/PagePostsDates.vue'

import PageSchedule from '@/app/views/schedule/PageSchedule.vue'
import PageHot17 from '@/app/views/schedule/PageHot17.vue'

import PageCategories from '@/app/views/blog/PageCategories.vue'
import PageBlog from '@/app/views/blog/PageBlog.vue'
import PageBlogBySlug from '@/app/views/blog/PageBlogBySlug.vue'
import PageBlogByCategory from '@/app/views/blog/PageBlogByCategory.vue'

import PageNews from '@/app/views/news/PageNews.vue'
import PageNewsBySlug from '@/app/views/news/PageNewsBySlug.vue'

import PageAbout from '@/app/views/about/PageAbout.vue'
import PageCrew from '@/app/views/about/PageCrew.vue'
import PageEditorialCollege from '@/app/views/about/PageEditorialCollege.vue'
import PageHistory from '@/app/views/about/PageHistory.vue'
import PageHowToListen from '@/app/views/about/PageHowToListen.vue'

import PageContact from '@/app/views/contact/PageContact.vue'
import PageCooperation from '@/app/views/contact/PageCooperation.vue'
import PageRecruitment from '@/app/views/contact/PageRecruitment.vue'
import PagePrivacyPolicy from '@/app/views/contact/PagePrivacyPolicy.vue'

import PageDownloads from '@/app/views/offer/PageDownloads.vue'
import PageServices from '@/app/views/offer/PageServices.vue'
import PageVoiceBank from '@/app/views/offer/PageVoiceBank.vue'

import PageShowPage from '@/app/views/PageShowPage.vue'

import Page404 from '@/app/views/Page404.vue'

const routes: Array<RouteConfig> = [
    { path: '/', name: 'home', component: PageHome },
    {
        path: '/search/:query([a-zA-ZÀ-ž0-9% ]+)?',
        name: 'search',
        component: PageSearch,
        props: (route: Route): Record<string, unknown> => {
            const query = route.params.query as (string | undefined)

            return {
                query: query === undefined ? '' : query
            }
        }
    },

    {
        path: '/posts/author/:id([0-9]+)/:page([0-9]+)?',
        name: 'posts.by-author',
        component: PagePostsByAuthor,
        props: (route: Route): Record<string, unknown> => {
            const page = route.params.page as (string | undefined)

            return {
                page: page === undefined ? 1 : parseInt(page, 10),
                id: parseInt(route.params.id, 10)
            }
        }
    },
    {
        path: '/posts/date/:date([0-9]{4}-[0-9]{2}-[0-9]{2})/:page([0-9]+)?',
        name: 'posts.by-date',
        component: PagePostsByDate,
        props: (route: Route): Record<string, unknown> => {
            const page = route.params.page as (string | undefined)

            return {
                page: page === undefined ? 1 : parseInt(page, 10),
                date: new Date(Date.parse(route.params.date))
            }
        }
    },
    { path: '/posts/dates', name: 'posts.dates', component: PagePostsDates },
    {
        path: '/posts/tag/:slug([a-z0-9-]+)/:page([0-9]+)?',
        name: 'posts.by-tag',
        component: PagePostsByTag,
        props: (route: Route): Record<string, unknown> => {
            const page = route.params.page as (string | undefined)

            return {
                page: page === undefined ? 1 : parseInt(page, 10),
                slug: route.params.slug
            }
        }
    },

    {
        path: '/news/:page([0-9]+)?',
        name: 'news',
        component: PageNews,
        props: (route: Route): Record<string, unknown> => {
            const page = route.params.page as (string | undefined)

            return {
                page: page === undefined ? 1 : parseInt(page, 10)
            }
        }
    },
    { path: '/news/:slug([a-z0-9-]+)', name: 'news.by-slug', component: PageNewsBySlug, props: true },

    { path: '/schedule', name: 'schedule', component: PageSchedule },
    { path: '/hot-17', name: 'schedule.hot-17', component: PageHot17 },

    { path: '/blog/categories', name: 'blog.categories', component: PageCategories },
    {
        path: '/blog/:page([0-9]+)?',
        name: 'blog',
        component: PageBlog,
        props: (route: Route): Record<string, unknown> => {
            const page = route.params.page as (string | undefined)

            return {
                page: page === undefined ? 1 : parseInt(page, 10)
            }
        }
    },
    { path: '/blog/:slug([a-z0-9-]+)', name: 'blog.by-slug', component: PageBlogBySlug, props: true },
    {
        path: '/blog/category/:slug([a-z0-9-]+)/:page([0-9]+)?',
        name: 'blog.by-category',
        component: PageBlogByCategory,
        props: (route: Route): Record<string, unknown> => {
            const page = route.params.page as (string | undefined)

            return {
                page: page === undefined ? 1 : parseInt(page, 10),
                slug: route.params.slug
            }
        }
    },

    { path: '/about', name: 'about', component: PageAbout },
    { path: '/about/crew', name: 'about.crew', component: PageCrew },
    { path: '/about/editorial-college', name: 'about.editorial-college', component: PageEditorialCollege },
    { path: '/about/history', name: 'about.history', component: PageHistory },
    { path: '/about/how-to-listen', name: 'about.how-to-listen', component: PageHowToListen },

    { path: '/contact', name: 'contact', component: PageContact },
    { path: '/contact/cooperation', name: 'contact.cooperation', component: PageCooperation },
    { path: '/contact/recruitment', name: 'contact.recruitment', component: PageRecruitment },

    { path: '/privacy-policy', name: 'privacy-policy', component: PagePrivacyPolicy },

    { path: '/downloads', name: 'downloads', component: PageDownloads },
    { path: '/services', name: 'services', component: PageServices },
    { path: '/voice-bank', name: 'voice-bank', component: PageVoiceBank },

    { path: '/page/:page([a-z0-9-]+)', name: 'page.show', component: PageShowPage, props: true },

    { path: '/404', alias: '*', name: '404', component: Page404 }
]

export default routes
